import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ReturnServices from '@root/modules/Sellers/Return/services/return';
import ReturnDetailOrder from '../../Return/pages/return-not-access/ReturnDetailOrder';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import { Card } from 'antd';

const ShippingReturnDisposalDetail = () => {
  const listBreadcrumb = [
    {
      tittle: '반환/폐기 관리',
      url: '/admin/seller/shipping'
    },
    {
      tittle: '폐기 조회',
      url: '/admin/seller/shipping/return-disposal'
    },
    {
      tittle: '폐기 상세',
      url: ''
    }
  ];

  const { productId }: any = useParams();
  const [productComment, setProductComment] = useState([] as any);
  const [productOrder, setProductOrder] = useState([] as any);
  const [recipient, setRecipient] = useState({});

  const getDetailReturn = async () => {
    const returnDetail = await ReturnServices.getDetailReturn(productId);
    setRecipient(returnDetail.data);
    setProductComment(returnDetail.data.order);
    const products = returnDetail.data?.orderProducts.products || [];
    setProductOrder(products);
  };

  useEffect(() => {
    getDetailReturn();
  }, []);

  return (
    <>
      <BreadcrumbList listBreadcrumb={listBreadcrumb} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card btnImport"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <ReturnDetailOrder
            recipient={recipient}
            productComment={productComment}
            productOrder={productOrder}
            refetch={getDetailReturn}
            screenName="ReturnDisposalDetail"
          />
        </Card>
      </div>
    </>
  );
};
export default ShippingReturnDisposalDetail;
